import { useRef, useState } from 'react';

import { api } from '~/shared/lib/api';

import { POLLING_INTERVAL } from '../constants/defaultValues';
import { createInteraction } from '../utils/customerInteraction';

type AsyncDelay = (delay?: number) => Promise<void>;

export const asyncDelay: AsyncDelay = (delay = 1000) =>
  new Promise((resolve) => setTimeout(() => resolve(), delay));

type UseSessionPollingHook = (params: {
  hash: string;
  sessionId: string;
  onError: VoidFunction;
  onSessionError: VoidFunction;
  onSuccess: VoidFunction;
  onRedirect: (url: string) => void;
}) => {
  loading: boolean;
  startPolling: VoidFunction;
};

export const useSessionPolling: UseSessionPollingHook = (params) => {
  const { hash, sessionId, onError, onSessionError, onSuccess, onRedirect } =
    params;

  const [loading, setLoading] = useState(false);

  const hasRedirectRef = useRef(false);

  const fetchStatus = async () => {
    setLoading(true);

    try {
      const { data } = await api.get(`/api/session/${sessionId}/${hash}`);
      const { sessionStatus, payment } = data;

      const { customerInteraction } = payment;

      if (
        sessionStatus === 'in_progress' &&
        customerInteraction &&
        !hasRedirectRef.current
      ) {
        hasRedirectRef.current = true;

        // редирект для 3ds, открываем новую страницу в браузере на которой делаем запрос сесссии и автосабмит формы
        if (customerInteraction.type === 'redirect') {
          const redirectPageUrl = new URL('/redirect', window.location.origin);
          redirectPageUrl.searchParams.set('sessionId', sessionId);
          redirectPageUrl.searchParams.set('hash', hash);

          onRedirect(redirectPageUrl.toString());
        } else if (customerInteraction.type === 'inform') {
          const interaction = createInteraction(customerInteraction);

          if (interaction) {
            onRedirect(interaction);
          }
        }
      }

      if (['error', 'cancelled'].includes(sessionStatus)) {
        setLoading(false);

        onSessionError();

        return;
      }

      if (sessionStatus === 'accepted') {
        setLoading(false);

        onSuccess();

        return;
      }

      await asyncDelay(POLLING_INTERVAL);

      fetchStatus();
    } catch (error) {
      setLoading(false);

      onError();

      console.error(error);
    }
  };

  const startPolling = () => {
    fetchStatus();
  };

  return { loading, startPolling };
};
